import { createStyles, Theme } from '@material-ui/core/styles';

import { colours } from '@shared/theme/colours';

export const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {
      boxSizing: 'border-box',
      height: '100vh',
      padding: spacing(5),
      width: '100vw',
    },

    content: {
      backgroundImage: `linear-gradient(to bottom, transparent 50%, ${colours.neutral[200]} 50%), linear-gradient(to right, ${colours.neutral[50]} 50%, ${colours.neutral[200]} 50%)`,
      backgroundSize: '10px 10px, 10px 10px',
      boxSizing: 'border-box',
      height: '100%',
      padding: spacing(5),
    },

    innerContent: {
      // backgroundColor: colours.solid.white,
      height: '100%',
      overflowY: 'auto',
    },
  });
